module.exports = __webpack_public_path__ + "img/SkiChallengeNew.2b66162a.png";